/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * DeviceGuiService
 */
    
namespace Application.Services {
    'use strict';

    import DeviceGui = Models.DeviceGui;
    import IHalElement = Models.IHalElement;
    import HalConverter = Models.HalConverter;
    
    /**
     * DeviceGuiService
     */
    export class DeviceGuiService {
        public static $name: string = 'deviceGuiService';
        public static $inject: string[] = ['$http', 'backendService', '$q', '$timeout'];

        private static maxRequestWait: number = 600;

        private http: ng.IHttpService;
        private backendService: BackendService;
        private $q: ng.IQService;
        private $timeout: ng.ITimeoutService;
        private backendBaseUrl: string = window.backendUrl;
        // private servicePath: string = 'flexocore/';
        private servicePath: string = '';
        private deviceGuiBackendUrl: string = this.backendBaseUrl + this.servicePath + 'devicegui';
        private requestQueueLength: number = 10;
        private requestQueue: IdDeferredRequestMap;
        private requestQueueTimer: ng.IPromise<void>;


        constructor($http: ng.IHttpService, backendService: BackendService, $q: ng.IQService, $timeout: ng.ITimeoutService) {
            this.http = $http;
            this.backendService = backendService;
            this.$q = $q;
            this.$timeout = $timeout;
            this.requestQueue = {};
        }

        public getDeviceGuiByBlockId(blockId: string): ng.IPromise<DeviceGui> {
            return this.http
                .get(this.deviceGuiBackendUrl + '/' + blockId)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<DeviceGui>>) => {
                    let halElement: IHalElement<DeviceGui> = data.data;
                    let converted: DeviceGui = HalConverter.convertElement(halElement, DeviceGui.Empty);
                    if (!!converted.guiUrl) {
                        if (!converted.absolute)
                            converted.guiUrl = this.backendBaseUrl + converted.guiUrl.substr(1);
                    } else {
                        converted.guiUrl = undefined;
                    }
                    return converted;
                });
        }

        public getDeviceGuiByIdPromise(nodeId: number): ng.IPromise<DeviceGui> {
            return this.http
                .get(this.deviceGuiBackendUrl + '/node/' + nodeId)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<DeviceGui>>) => {
                    let halElement: IHalElement<DeviceGui> = data.data;
                    let converted: DeviceGui = HalConverter.convertElement(halElement, DeviceGui.Empty);
                    if (converted.guiUrl && converted.guiUrl !== '') {
                        if (!converted.absolute)
                            converted.guiUrl = this.backendBaseUrl + converted.guiUrl.substr(1);
                    } else
                        converted.guiUrl = undefined;
                    if (converted.apiUrl && converted.apiUrl !== '') {
                        converted.apiUrl = this.backendBaseUrl + converted.apiUrl.substr(1);
                    } else 
                        converted.apiUrl = undefined;
                    return converted;
                });
        }

        public getDeviceGuiByIdPromiseGrouping(id: number): ng.IPromise<DeviceGui> {
            let request: DeferredRequest = this.getOrCreateNewRequest(id, this.requestQueue);
            return request.deferred.promise;
        }

        public notifyAdvancedSettingsAttempt(networkNodeHref: string, deviceGui: DeviceGui): ng.IPromise<void> {
            return this.http
                .post(this.deviceGuiBackendUrl + '/advancedSettingsAttempt/' + networkNodeHref, deviceGui)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<void>>) => {
                    return;
                });
        }

        public notifyAdminSettingsAttempt(networkNodeHref: string, deviceGui: DeviceGui): ng.IPromise<void> {
            return this.http
                .post(this.deviceGuiBackendUrl + '/adminSettingsAttempt/' + networkNodeHref, deviceGui)
                .then((data: ng.IHttpPromiseCallbackArg<IHalElement<void>>) => {
                    return;
                });
        }

        private getOrCreateNewRequest(id: number, idMap: IdDeferredRequestMap): DeferredRequest {
            if (idMap[id] === undefined) {
                idMap[id] = [];
            }
            let requests: DeferredRequest[] = idMap[id];
            let guiRequest: DeferredRequest = new DeferredRequest(id, this.$q.defer());
            requests.push(guiRequest);

            let size: number = Object.keys(idMap).length;
            if (size >= this.requestQueueLength ) {
                this.doMakeRequests();
            } else {
                if (!this.requestQueueTimer) {
                    this.requestQueueTimer = this.$timeout(() => {
                        // if we go over max time without reaching the desired length, request anyway
                        this.doMakeRequests();
                        this.requestQueueTimer = undefined;
                    }, DeviceGuiService.maxRequestWait);
                }
            }

            return guiRequest;
        }

        private doMakeRequests(): void {
            let tmpRequestQueue: IdDeferredRequestMap = this.requestQueue;
            this.requestQueue = {};
            if (Object.keys(tmpRequestQueue).length > 0)
                this.getListPromise(tmpRequestQueue, this.deviceGuiBackendUrl + '/node/list' );
        }

        private getListPromise(requestMap: IdDeferredRequestMap, url: string): void {
            let ids: number[] = Object.keys(requestMap).map((value: string) => {
                return parseInt(value, 10);
            });
            let requests: DeferredRequest[][] = ids.map((id: number) => {
                return requestMap[id];
            });
            this.backendService.post(url, ids)
                .then((result: ng.IHttpPromiseCallbackArg<Models.IHalElement<DeviceGui>[]>) => {
                    let entities: Models.IHalElement<DeviceGui>[] = result.data;
                    entities.forEach((halElement: Models.IHalElement<DeviceGui>, index: number) => {
                        let entity: DeviceGui = halElement ? HalConverter.convertElement(halElement, DeviceGui.Empty) : undefined;
                        let requestsForIndex: DeferredRequest[] = requests[index];
                        requestsForIndex.forEach((request: DeferredRequest) => {
                            request.deferred.resolve(entity);
                        });
                    });
                });
        }
        
   }

}
